import * as React from 'react';
import styles from './mfa-header.module.css';

type Props = {
    children?: React.ReactNode;
    as: string;
};

MfaHeader.defaultProps = {
    as: 'div',
};

export function MfaHeader({children, as: Tag}: Props) {
    // @ts-expect-error
    return <Tag className={styles['mfa-header']}>{children}</Tag>;
}
